(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendationsIntoSection() {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    };
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = Station.Theme.shop.root + 'recommendations/products?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        window
          .Station
          .Theme
          .Currency
          .init();
        window
          .Station
          .Theme
          .Cart
          .init();
      };
    };
    request.send();
  };
  document.addEventListener('DOMContentLoaded', function(event) {
    loadProductRecommendationsIntoSection();
  });
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    };
  });

  } catch(e) { console.error(e); }
})();
})();
